import { useState } from "react";

const colorFromName = (name?: string | null) => {
  if (!name) return "#9aa0ac";
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 60%, 55%)`;
};

interface AvatarProps {
  onClick?: () => void;
  online?: boolean;
  image?: string | null;
  text?: string | null;
  background?: string;
  width?: number;
  height?: number;
  colorful?: boolean;
}

const Avatar = ({
  onClick,
  online,
  image,
  text,
  background = "gray",
  width = 50,
  height = 50,
  colorful = false,
}: AvatarProps) => {
  const isInteractive = !!onClick;
  const pictureBackground = colorful ? colorFromName(text) : background;
  const [brokenSrc, setBrokenSrc] = useState<string | null>(null);
  const showImage = Boolean(image) && image !== brokenSrc;
  return (
    <div
      className={"jf-avatar " + (isInteractive ? " jf-pointer" : "")}
      onClick={onClick}
      role={isInteractive ? "button" : "presentation"}
      tabIndex={isInteractive ? 0 : undefined}
      aria-label={isInteractive ? (text ? `Open ${text}` : "Open") : undefined}
      onKeyDown={(e) => {
        if (isInteractive && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick?.();
        }
      }}
      style={{
        width,
        minWidth: width,
        height,
        minHeight: height,
      }}
    >
      {online && <div className="jf-avatar-online-icon" />}
      <div
        className="jf-avatar-picture"
        style={{ backgroundColor: pictureBackground }}
      >
        {showImage ? (
          <img src={image || ""} alt="" onError={() => setBrokenSrc(image || "")} />
        ) : (
          <span style={{ fontSize: width * 0.4 }}>
            {text && text.charAt(0).toLocaleUpperCase()}
          </span>
        )}
      </div>
    </div>
  );
};

export default Avatar;
